module.exports = __webpack_public_path__ + "img/05.8cada25f.jpg";